import SelectedIcon from '../../../../assets/icons/signup-selected.svg';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ModalQuickFileTab.less';

export type ModalQuickFileTabValue = 'media' | 'audio';

interface ModalQuickFileTabProps {
  onChange: (value: ModalQuickFileTabValue) => void;
  initialValue?: ModalQuickFileTabValue;
}

const ModalQuickFileTab = ({ onChange, initialValue = 'media' }: ModalQuickFileTabProps) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<ModalQuickFileTabValue>(initialValue);

  const handleSwitchClick = (value: ModalQuickFileTabValue) => {
    setSelected(value);
    onChange(value);
  };

  const options: { key: ModalQuickFileTabValue; label: string }[] = [
    { key: 'media', label: t('photos-videos') },
    { key: 'audio', label: t('audios') },
  ];

  return (
    <div className="modal-quick-file-tab-wrapper">
      <div className="modal-quick-file-switch-container">
        {options.map((opt) => (
          <div
            key={opt.key}
            className={`modal-quick-file-switch ${selected === opt.key ? 'selected' : ''}`}
            onClick={() => handleSwitchClick(opt.key)}
            role="button"
            tabIndex={0}
            aria-pressed={selected === opt.key}
          >
            <div className="modal-qf-switch-content">
              {selected === opt.key && <img src={SelectedIcon} className="modal-qf-selected-icon" alt="Selected" />}
              <span className={`modal-quick-file-switch-text ${selected === opt.key ? 'white' : ''}`}>{opt.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ModalQuickFileTab;
